/**
 * Whitelist dei path inoltrabili dal deep-link handler (`appUrlOpen`).
 *
 * I deep-link sono App Links verificati (`https://www.ceralia.it/...`), ma
 * l'handler non deve inoltrare ciecamente qualunque path ricevuto: limitiamo
 * il redirect interno alle sole rotte note dell'app, così un intent verso un
 * path arbitrario viene scartato invece di essere propagato a window.location.
 */

// Rotte reali definite in src/routes/AppRoutes.tsx (mantenere allineata).
export const ALLOWED_DEEPLINK_PATHS: ReadonlySet<string> = new Set([
  "/",
  "/home",
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
  "/password-reset-success",
  "/verify-email",
  "/verify-bridge",
  "/logout",
  "/profile",
  "/shopping",
  "/settings",
  "/offline-config",
  "/lists",
  "/categories",
  "/products",
  "/shopping-history",
  "/shared-lists",
  "/premium",
  "/premium-success",
  "/shops",
  "/import-shops",
  "/devices",
  "/recurring-products",
  "/license",
  "/privacy-policy",
  "/data-deletion",
]);

/**
 * Normalizza un pathname rimuovendo trailing slash multipli.
 */
export const normalizeDeepLinkPath = (pathname: string): string => {
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
};

/**
 * Restituisce true se il path è tra quelli inoltrabili dal deep-link handler.
 */
export const isAllowedDeepLinkPath = (pathname: string): boolean =>
  ALLOWED_DEEPLINK_PATHS.has(normalizeDeepLinkPath(pathname));
